export const getPaymentSeverity = (status: string) => {
  switch (status) {
    case "PAID":
      return "success";
    case "UNPAID":
      return "danger";
    default:
      return "info";
  }
};
